export default __webpack_public_path__ + "static/media/25_2_2.d9116d87.png";